import { IconButton, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import WhiteCard from "src/shared/components/WhiteCard";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CustomChip from "src/shared/components/CustomChip";

interface Props {
  count: number;
  increase: () => void;
  decrease: () => void;
}

const PillCounter = ({ count, decrease, increase }: Props) => {
  const { t } = useTranslation();
  const component = "pill-counter";

  const label = useMemo(() => {
    return t(`${component}.label`, "Select pills per month");
  }, [t]);

  const disclaimer = useMemo(() => {
    return t(`${component}.disclaimer`, "Most people use 4–8 pills per month");
  }, [t]);

  return (
    <Stack>
      <CustomChip label={label} color="#023047A8" />
      <WhiteCard alignItems={"center"}>
        <Stack direction={"row"} alignItems={"center"} gap={2}>
          <IconButton
            onClick={decrease}
            disabled={count <= 4}
            sx={{
              backgroundColor: "#CDCDCD",
              border: "1px solid #CDCDCD",
              "&:hover": {
                backgroundColor: "#00B6B92E",
                borderColor: "#00B6B92E",
              },
            }}
          >
            <RemoveIcon />
          </IconButton>
          <Typography variant="h5" fontWeight={700}>
            {count}
          </Typography>
          <IconButton
            onClick={increase}
            disabled={count >= 20}
            sx={{
              backgroundColor: "#CDCDCD",
              border: "1px solid #CDCDCD",
              "&:hover": {
                backgroundColor: "#00B6B92E",
                borderColor: "#00B6B92E",
              },
            }}
          >
            <AddIcon />
          </IconButton>
        </Stack>
        <Typography color="#56575B" fontStyle={"italic"}>
          {disclaimer}
        </Typography>
      </WhiteCard>
    </Stack>
  );
};

export default PillCounter;
